import * as React from "react";
import cx from "classnames";
import style from "./History.css";
import shape from "_images/shape1.svg";
import cadcad from "./img/cadcad.svg";

let WOW = function() {};
if (typeof window !== "undefined") {
  WOW = require("wowjs");
}

export class History extends React.Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      let wow = new WOW({
        mobile: false,
        live: true,
        scrollContainer: null,
        offset: 80,
      });
      wow.init();
    }

    const { location } = this.props;

    if (location && location.state && location.state.scrollTo) {
      this.anchor.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location } = nextProps;
    if (location && location.state && location.state.scrollTo) {
      this.anchor.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  render() {
    return (
      <div className={style.root}>
        <header className={style.header}>
          <img
            className={cx(style.shape, style.shape1, "rotation slow")}
            src={shape}
          />
          <img
            className={cx(style.shape, style.shape2, "rotation slower")}
            src={shape}
          />
          <img
            className={cx(style.shape, style.shape3, "rotation slow")}
            src={shape}
          />

          <div className="container">
            <h1 className={cx(style.title, "wow", "fadeInUp")}>History</h1>
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              BlockScience was founded in the fall of 2017 by Dr. Michael
              Zargham who felt that the interdisciplinary study of
              socio-technical and economic systems needed to break out of
              academia and find its place amongst the real-world businesses
              migrating from static enterprise systems to dynamic, increasingly
              decentralized, ecosystems.
            </p>
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              <a
                href="https://medium.com/block-science/personal-research-statement-b09defefc331"
                target="_blank"
                rel="noopener noreferrer"
                className={cx(style.whiteLink, "wow", "fadeInUp")}
                data-wow-delay="0.25s"
              >
                Personal Research Statement
              </a>
            </p>
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              In early 2018, an internal BlockScience research project led by
              Fernando Martinelli exploring multidimensional invariant surfaces,
              developed the powerful mathematical framework implemented by{" "}
              <a
                href="https://balancer.fi"
                target="_blank"
                className={cx(style.whiteLink)}
              >
                Balancer
              </a>{" "}
              that enables portfolios to continuously self-rebalance while also
              generating fees.
            </p>
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              At the August 2019 Token Engineering Global Gathering (TEGG)
              BlockScience open-sourced{" "}
              <a
                href="https://cadcad.org"
                target="_blank"
                className={cx(style.whiteLink)}
              >
                cadCAD
              </a>
              , a Python package developed to streamline the process of
              designing, testing, and validating complex systems through
              simulations and provide the ability to create digital twins for
              operating ecosystems.
            </p>
            <img className={cx(style.shape2, "wow", "fadeInUp")} src={cadcad} />
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              In October 2020, the Filecoin network{" "}
              <a
                href="https://filecoin.io/blog/posts/filecoin-mainnet-is-live/"
                target="_blank"
                className={cx(style.whiteLink)}
              >
                launched
              </a>
              , to which contributions to the economic design had been one of
              the most long standing and significant projects at BlockScience.
            </p>
            <p
              className={cx(style.text, "wow", "fadeInUp")}
              data-wow-delay="0.25s"
            >
              2021 saw the launch of BlockScience Labs, a data science product development company that is developing a
              SaaS web app that creates collaborative, version-controlled
              project spaces that provide a single source of truth for the data,
              analytics, and decisions involved in answering complex business
              problems.
            </p>
            <p className={cx(style.spacer)}>HELLO</p>
          </div>
        </header>
        {}
      </div>
    );
  }
}
